import PropTypes from 'prop-types';
import { useEffect } from 'react';

import { Autoplay, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { api_getProductsByIds } from '~/backend/api_calls';
import ProductCard from '~/components/common/ProductCard/ProductCard';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import { ProductCardLoader } from '~/components/common/SkeletonLoaders';

const ProductsEntries = ({ products, setProducts, productsIds, showDimensions = false }) => {
	useEffect(() => {
		api_getProductsByIds(productsIds.toString())
			.then(json => {
				setProducts(json.items);
			})
			.catch(error => {
				console.error(error);
			});
	}, [productsIds]);

	return (
		<Swiper
			modules={[Pagination, Navigation, Autoplay]}
			pagination={{
				dynamicBullets: true,
				clickable: true
			}}
			navigation={false}
			autoplay={{
				delay: 2500,
				disableOnInteraction: false
			}}
			slidesPerView={'auto'}
			spaceBetween={10}
			className="mySwiper">
			{products.length == 0 ? (
				<>
					<SwiperSlide>
						<ProductCardLoader />
					</SwiperSlide>
					<SwiperSlide>
						<ProductCardLoader />
					</SwiperSlide>
					<SwiperSlide>
						<ProductCardLoader />
					</SwiperSlide>
					<SwiperSlide>
						<ProductCardLoader />
					</SwiperSlide>
				</>
			) : (
				products.map((product, index) => (
					<SwiperSlide key={index}>
						<ProductCard product={product} showDimensions={showDimensions} />
					</SwiperSlide>
				))
			)}
		</Swiper>
	);
};

ProductsEntries.propTypes = {
	products: PropTypes.array,
	setProducts: PropTypes.func,
	productsIds: PropTypes.array,
	showDimensions: PropTypes.bool
};

export default ProductsEntries;
